<script>
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome/src/components/FontAwesomeIcon';
    export default FontAwesomeIcon;
</script>
